var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_xD83D__xDD0D_-Product-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_copy_image_24_filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_xD83C__xDFA8_-Color",
    className: "st0",
    d: "M458.4,66.7c38.6,0,70.3,29.2,74.4,66.6l58.8,0c39.7,0,72.2,30.8,74.8,69.9 l0.2,5.1v49.9c0,13.8-11.2,25-25,25c-12.7,0-23.1-9.4-24.8-21.6l-0.2-3.4v-49.9c0-12.7-9.4-23.1-21.6-24.8l-3.4-0.2l-71.1,0 c-13.4,20-36.3,33.1-62.2,33.1H341.6c-25.9,0-48.7-13.1-62.2-33.1l-71.1,0c-12.7,0-23.1,9.4-24.8,21.6l-0.2,3.4v450.2 c0,12.7,9.4,23.1,21.6,24.8l3.4,0.2h50.2c13.8,0,25,11.2,25,25c0,12.7-9.4,23.1-21.6,24.8l-3.4,0.2h-50.2 c-39.7,0-72.2-30.8-74.8-69.9l-0.2-5.1V208.3c0-39.7,30.8-72.2,69.9-74.8l5.1-0.2l58.8,0c4.1-37.5,35.9-66.6,74.4-66.6H458.4z  M547.9,583.7l3.1,2.7l130.9,130.9c-16.5,10.2-36,16.1-56.9,16.1H441.7c-20.9,0-40.3-5.9-56.9-16.1l130.9-130.9l2.8-2.4 c7.6-5.6,17.7-6.4,26-2.3L547.9,583.7L547.9,583.7z M625,333.3c59.8,0,108.3,48.5,108.3,108.3V625c0,20.9-5.9,40.3-16.1,56.9 L586.4,551l-4.3-4c-27.9-23.9-69.2-24-97.2-0.2l-4.5,4.2L349.4,681.9c-10.2-16.5-16.1-36-16.1-56.9V441.7 c0-59.8,48.5-108.3,108.3-108.3H625z M616.7,416.7c-18.4,0-33.3,14.9-33.3,33.3c0,18.4,14.9,33.3,33.3,33.3S650,468.4,650,450 C650,431.6,635.1,416.7,616.7,416.7z M458.4,116.7H341.6c-13.7,0-24.9,11.1-24.9,24.9s11.1,24.9,24.9,24.9h116.9 c13.7,0,24.9-11.1,24.9-24.9S472.2,116.7,458.4,116.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyImageIcon);
export default __webpack_public_path__ + "static/media/copy_image_icon.123473654cc3e2b29bb29634098d198d.svg";
export { ForwardRef as ReactComponent };